import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  createLocation,
  deleteLocation,
  getLocations,
  updateLocation,
} from "../services/settingsService";

const normalizeLocations = (payload) => {
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data?.locations)) return payload.data.locations;
  if (Array.isArray(payload?.locations)) return payload.locations;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const useOfficeLocations = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);

  const loadLocations = async () => {
    try {
      setLoading(true);
      const res = await getLocations();
      setLocations(normalizeLocations(res));
    } catch {
      toast.error("Failed to load locations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLocations();
  }, []);

  const openCreate = () => {
    setEditingLocation(null);
    setModalOpen(true);
  };

  const openEdit = (location) => {
    setEditingLocation(location);
    setModalOpen(true);
  };

  const removeLocation = async (id) => {
    try {
      await deleteLocation(id);
      toast.success("Location deleted");
      await loadLocations();
    } catch {
      toast.error("Failed to delete location");
    }
  };

  const saveLocation = async (data) => {
    try {
      if (editingLocation?._id) {
        await updateLocation(editingLocation._id, data);
        toast.success("Location updated");
      } else {
        await createLocation(data);
        toast.success("Location added");
      }
      setModalOpen(false);
      await loadLocations();
      return true;
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save location");
      return false;
    }
  };

  return {
    locations,
    loading,
    modalOpen,
    setModalOpen,
    editingLocation,
    openCreate,
    openEdit,
    removeLocation,
    saveLocation,
  };
};




